/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Contact_Meta_DescriptionInputs */

const en_contact_meta_description = /** @type {(inputs: Contact_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Get in touch with Mark Egly Golf in Des Moines, Iowa. Call 515-289-1703 or email ${i?.email}.`)
};

const es_contact_meta_description = /** @type {(inputs: Contact_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Comunícate con Mark Egly Golf en Des Moines, Iowa. Llama al 515-289-1703 o escribe a ${i?.email}.`)
};

const de_contact_meta_description = /** @type {(inputs: Contact_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nehmen Sie Kontakt mit Mark Egly Golf in Des Moines, Iowa auf. Rufen Sie 515-289-1703 an oder senden Sie eine E-Mail an ${i?.email}.`)
};

const zh_contact_meta_description = /** @type {(inputs: Contact_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`与爱荷华州得梅因的 Mark Egly Golf 取得联系。请致电 515-289-1703 或发送电子邮件至 ${i?.email}。`)
};

const ar_contact_meta_description = /** @type {(inputs: Contact_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`تواصل مع Mark Egly Golf في Des Moines, Iowa. اتصل على 515-289-1703 أو راسل ${i?.email}.`)
};

const fr_contact_meta_description = /** @type {(inputs: Contact_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Entrez en contact avec Mark Egly Golf à Des Moines, Iowa. Appelez le 515-289-1703 ou envoyez un courriel à ${i?.email}.`)
};

const vi_contact_meta_description = /** @type {(inputs: Contact_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Liên hệ Mark Egly Golf tại Des Moines, Iowa. Gọi 515-289-1703 hoặc gửi email ${i?.email}.`)
};

const sw_contact_meta_description = /** @type {(inputs: Contact_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wasiliana na Mark Egly Golf huko Des Moines, Iowa. Piga simu 515-289-1703 au barua pepe ${i?.email}.`)
};

const th_contact_meta_description = /** @type {(inputs: Contact_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ติดต่อกับ Mark Egly Golf ในเมืองดิมอยน์ รัฐไอโอวา โทร 515-289-1703 หรืออีเมล ${i?.email}`)
};

const bs_contact_meta_description = /** @type {(inputs: Contact_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Javite se Mark Egly Golf u Des Moinesu, Iowa. Nazovite 515-289-1703 ili pišite na ${i?.email}.`)
};

const ja_contact_meta_description = /** @type {(inputs: Contact_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Iowa州Des MoinesのMark Egly Golfへのお問い合わせは、お電話（515-289-1703）またはメール（${i?.email}）でどうぞ。`)
};

const ko_contact_meta_description = /** @type {(inputs: Contact_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Des Moines, Iowa의 Mark Egly Golf에 문의하세요. 전화 515-289-1703 또는 이메일 ${i?.email}.`)
};

const pt_contact_meta_description = /** @type {(inputs: Contact_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Entre em contato com Mark Egly Golf em Des Moines, Iowa. Ligue para 515-289-1703 ou e-mail ${i?.email}.`)
};

const it_contact_meta_description = /** @type {(inputs: Contact_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Contatta Mark Egly Golf a Des Moines, Iowa. Chiama il 515-289-1703 o scrivi a ${i?.email}.`)
};

const sv_contact_meta_description = /** @type {(inputs: Contact_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kom i kontakt med Mark Egly Golf i Des Moines, Iowa. Ring 515-289-1703 eller e-post ${i?.email}.`)
};

const nl_contact_meta_description = /** @type {(inputs: Contact_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Neem contact op met Mark Egly Golf in Des Moines, Iowa. Bel 515-289-1703 of e-mail ${i?.email}.`)
};

const da_contact_meta_description = /** @type {(inputs: Contact_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kontakt Mark Egly Golf i Des Moines, Iowa. Ring 515-289-1703 eller e-mail ${i?.email}.`)
};

const nb_contact_meta_description = /** @type {(inputs: Contact_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kontakt Mark Egly Golf i Des Moines, Iowa. Ring 515-289-1703 eller e-post ${i?.email}.`)
};

const fi_contact_meta_description = /** @type {(inputs: Contact_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ota yhteyttä Mark Egly Golfiin Des Moinesissa, Iowassa. Soita 515-289-1703 tai lähetä sähköpostia osoitteeseen ${i?.email}.`)
};

const pl_contact_meta_description = /** @type {(inputs: Contact_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Skontaktuj się z Mark Egly Golf w Des Moines, Iowa. Zadzwoń pod 515-289-1703 lub napisz na ${i?.email}.`)
};

const ru_contact_meta_description = /** @type {(inputs: Contact_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Свяжитесь с Mark Egly Golf в Des Moines, Iowa. Позвоните по телефону 515-289-1703 или по электронной почте ${i?.email}.`)
};

const tr_contact_meta_description = /** @type {(inputs: Contact_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Des Moines, Iowa'daki Mark Egly Golf ile iletişime geçin. 515-289-1703 numarasını arayın veya ${i?.email} adresine e-posta gönderin.`)
};

const hi_contact_meta_description = /** @type {(inputs: Contact_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Des Moines, Iowa में Mark Egly Golf से संपर्क करें। कॉल 515-289-1703 या ईमेल ${i?.email}।`)
};

const id_contact_meta_description = /** @type {(inputs: Contact_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hubungi Mark Egly Golf di Des Moines, Iowa. Hubungi 515-289-1703 atau email ${i?.email}.`)
};

const ms_contact_meta_description = /** @type {(inputs: Contact_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hubungi Mark Egly Golf di Des Moines, Iowa. Telefon 515-289-1703 atau e-mel ${i?.email}.`)
};

const cs_contact_meta_description = /** @type {(inputs: Contact_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Spojte se s Mark Egly Golf v Des Moines, Iowa. Zavolejte 515-289-1703 nebo e-mail ${i?.email}.`)
};

const el_contact_meta_description = /** @type {(inputs: Contact_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Επικοινωνήστε με το Mark Egly Golf σε Des Moines, Iowa. Καλέστε 515-289-1703 ή email ${i?.email}.`)
};

const he_contact_meta_description = /** @type {(inputs: Contact_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`צרו קשר עם Mark Egly Golf ב-Des Moines, Iowa. התקשרו ל-515-289-1703 או כתבו ל-${i?.email}.`)
};

const af_contact_meta_description = /** @type {(inputs: Contact_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Neem kontak op met Mark Egly Golf in Des Moines, Iowa. Bel 515-289-1703 of e-pos ${i?.email}.`)
};

const hu_contact_meta_description = /** @type {(inputs: Contact_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Keresse meg a Mark Egly Golfot Des Moines-ban (Iowa). Hívja az 515-289-1703-at, vagy írjon e-mailt: ${i?.email}.`)
};

/**
* | output |
* | --- |
* | "Get in touch with Mark Egly Golf in Des Moines, Iowa. Call 515-289-1703 or email {email}." |
*
* @param {Contact_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const contact_meta_description = /** @type {((inputs: Contact_Meta_DescriptionInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Meta_DescriptionInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_contact_meta_description(inputs)
	if (locale === "de") return de_contact_meta_description(inputs)
	if (locale === "zh") return zh_contact_meta_description(inputs)
	if (locale === "ar") return ar_contact_meta_description(inputs)
	if (locale === "fr") return fr_contact_meta_description(inputs)
	if (locale === "vi") return vi_contact_meta_description(inputs)
	if (locale === "sw") return sw_contact_meta_description(inputs)
	if (locale === "th") return th_contact_meta_description(inputs)
	if (locale === "bs") return bs_contact_meta_description(inputs)
	if (locale === "ja") return ja_contact_meta_description(inputs)
	if (locale === "ko") return ko_contact_meta_description(inputs)
	if (locale === "pt") return pt_contact_meta_description(inputs)
	if (locale === "it") return it_contact_meta_description(inputs)
	if (locale === "sv") return sv_contact_meta_description(inputs)
	if (locale === "nl") return nl_contact_meta_description(inputs)
	if (locale === "da") return da_contact_meta_description(inputs)
	if (locale === "nb") return nb_contact_meta_description(inputs)
	if (locale === "fi") return fi_contact_meta_description(inputs)
	if (locale === "pl") return pl_contact_meta_description(inputs)
	if (locale === "ru") return ru_contact_meta_description(inputs)
	if (locale === "tr") return tr_contact_meta_description(inputs)
	if (locale === "hi") return hi_contact_meta_description(inputs)
	if (locale === "id") return id_contact_meta_description(inputs)
	if (locale === "ms") return ms_contact_meta_description(inputs)
	if (locale === "cs") return cs_contact_meta_description(inputs)
	if (locale === "el") return el_contact_meta_description(inputs)
	if (locale === "he") return he_contact_meta_description(inputs)
	if (locale === "af") return af_contact_meta_description(inputs)
	if (locale === "hu") return hu_contact_meta_description(inputs)
	return en_contact_meta_description(inputs)
});